import { extendTheme } from '@chakra-ui/react';
import buttonTheme from './components/button/buttonTheme';
import colors, { CARNABY } from './colors';
import tagTheme from './components/tag/tagTheme';
import linkTheme from './components/link/linkTheme';
import inputTheme from './components/input/inputTheme';
import headingTheme from './components/heading/headingTheme';
import textTheme from './components/text/textTheme';
import cardTheme from './components/card/cardTheme.ts/cardTheme';
import { textareaTheme } from './components/textarea/textareaTheme';
import { modalTheme } from './components/modal/modalTheme';
import { selectTheme } from './components/select/selectTheme';
import tooltipTheme from './components/tooltip/tooltipTheme';
import { tabsTheme } from './components/tab/tabTheme';
import { stepperTheme } from './components/stepper/stepperTheme';
import { switchTheme } from './components/switch/switchTheme';
import checkboxTheme from './components/checkbox/checkboxTheme';
import { tableTheme } from './components/table/tableTheme';
import { drawerTheme } from './components/drawer/drawerTheme';
const theme = extendTheme({
  styles: {
    global: {
      '#root, html, body': {
        height: '100%',
        color: 'text.body'
      },
      ':host,:root': {
        '--chakra-ui-focus-ring-color': CARNABY.light
      }
    }
  },
  shadows: {
    'focus-ring-color': CARNABY.light,
    outline: '0 0 0 3px var(--chakra-ui-focus-ring-color)'
  },
  colors,
  fonts: {
    heading: `'Lexend Deca', 'sans-serif'`,
    body: `'Lexend Deca', 'sans-serif'`
  },
  components: {
    Tag: tagTheme,
    Button: buttonTheme,
    Link: linkTheme,
    Input: inputTheme,
    Heading: headingTheme,
    Text: textTheme,
    Card: cardTheme,
    Textarea: textareaTheme,
    Modal: modalTheme,
    Select: selectTheme,
    Tooltip: tooltipTheme,
    Tabs: tabsTheme,
    Stepper: stepperTheme,
    Switch: switchTheme,
    Checkbox: checkboxTheme,
    Table: tableTheme,
    Drawer: drawerTheme
  }
});
export default theme;